<template>
  <div>
    <div v-if="alert" :class="['quota-alert', isExceeded ? 'quota-alert--exceeded' : '']">
      <span class="mx-3">
        <template v-if="isExceeded">
          <b>🚫 ไม่สามารถนำเข้าเอกสารได้ — โควต้าการใช้งานเต็ม</b>
          <br />
          สิทธิ์คงเหลือ {{ remaining.toLocaleString() }} ฉบับ
          (ใช้งานครบ {{ (companyUsage.countsDocsAll || 0).toLocaleString() }} /
          {{ (paymentDetail.docsPerMonth || 0).toLocaleString() }} ฉบับแล้ว)
          <br />
          หากต้องการใช้งานต่อ กรุณาติดต่อฝ่ายบริการลูกค้า โทร.
          <a href="tel:0661105989" class="quota-alert__phone">066-110-5989</a>
        </template>
        <template v-else-if="isFull">
          <b>📋 โควต้าการใช้งานของคุณเต็มแล้ว</b>
          <br />
          ไม่สามารถนำเข้าเอกสารเพิ่มได้ (ใช้งานครบ
          {{ (companyUsage.countsDocsAll || 0).toLocaleString() }}/{{ (paymentDetail.docsPerMonth || 0).toLocaleString() }} ฉบับ)
          <br />
          สนใจเพิ่มโควต้า กรุณาติดต่อฝ่ายบริการลูกค้า โทร.
          <a href="tel:0661105989" class="quota-alert__phone">066-110-5989</a>
        </template>
        <template v-else>
          <b>⚠️ ใกล้ถึงขีดจำกัดของแพ็กเกจ</b>
          <br />
          ใช้งานแล้ว {{ (companyUsage.countsDocsAll || 0).toLocaleString() }} /
          {{ (paymentDetail.docsPerMonth || 0).toLocaleString() }} ฉบับ
          ({{ percentage }}%) — คงเหลือสิทธิ์ใช้งานอีก {{ remaining.toLocaleString() }} ฉบับ
          <br />
          สอบถามข้อมูลเพิ่มเติมได้ที่ฝ่ายบริการลูกค้า โทร.
          <a href="tel:0661105989" class="quota-alert__phone">066-110-5989</a>
        </template>
      </span>
      <v-icon color="#fff" class="mx-2" @click="dismissed = true">
        mdi-close-circle-outline
      </v-icon>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AlertQuotaLimit",
  computed: {
    ...mapState({
      companyUsage: (state) => state.companies.companyUsage,
      paymentDetail: (state) => state.paymentPlans.paymentDetail,
    }),
    percentage() {
      const used = Number(this.companyUsage?.countsDocsAll) || 0;
      const limit = Number(this.paymentDetail?.docsPerMonth) || 0;
      if (!used || !limit) return 0;
      return Math.round((used / limit) * 100);
    },
    remaining() {
      const used = Number(this.companyUsage?.countsDocsAll) || 0;
      const limit = Number(this.paymentDetail?.docsPerMonth) || 0;
      return Math.max(0, limit - used);
    },
    isFree() {
      return this.paymentDetail?.id === "free_month";
    },
    isFull() {
      return this.percentage === 100;
    },
    isExceeded() {
      return this.percentage > 100;
    },
    alert() {
      return !this.dismissed && !this.isFree && this.percentage >= 70;
    },
  },
  data: () => ({
    dismissed: false,
  }),
  watch: {
    isExceeded(val) {
      if (val) this.dismissed = false;
    },
    isFull(val) {
      if (val) this.dismissed = false;
    },
  },
  created() {
    const companyId = this.$route.params.companyId;
    if (companyId) {
      this.$store.dispatch("companies/getCompanyPlan", { companyID: companyId });
      const now = new Date();
      const yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
      this.$store
        .dispatch("companies/subscribeCompanyUsage", { companyID: companyId, date: yearMonth })
        .then((unsubscribe) => {
          this.unsubscribeUsage = unsubscribe;
        });
    }
  },
  beforeDestroy() {
    if (typeof this.unsubscribeUsage === "function") {
      this.unsubscribeUsage();
    }
  },
};
</script>

<style lang="scss">
.quota-alert {
  /* In flow inside .company-alerts (app-bar); stacks below the suspended ribbon. */
  min-width: 450px;
  max-width: 100%;
  padding: 12px 6px;
  background-color: #e07b20;
  border-radius: 12px !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 13.5px;
  line-height: 1.35;
  box-shadow: 0 4px 12px rgba(224, 123, 32, 0.25);

  &--exceeded {
    background-color: #c9242b;
  }

  &__phone {
    color: #e07b20;
    background: #ffffff;
    font-weight: bold;
    text-decoration: none;
    padding: 2px 10px;
    border-radius: 20px;
    white-space: nowrap;
  }

  &--exceeded &__phone {
    color: #c9242b;
  }

  @media only screen and (max-width: 700px) {
    min-width: 0;
    width: 100%;
  }
}
</style>
